import { computed } from 'vue'

// 新APIのベースURL
export const NEW_API_BASE_URL = process.env.NODE_ENV === 'development' 
  ? '/api'
  : `${process.env.VUE_APP_LC_API_URL}api`

// 新API用の共通ヘッダー
export const NEW_API_HEADERS = {
  'Content-Type': 'application/json',
  'Accept': 'application/json',
  'X-Requested-With': 'XMLHttpRequest'
}

// 開発環境用のトークン
export const DEV_API_TOKEN = '3af49fe9befc35add3cc30d19f76d3b6684faba86829f'

// 新API用の認証情報
// Basic認証情報の取得（未設定の場合はnullを返す）
const getApiAuth = () => {
  const username = process.env.VUE_APP_LC_API_URL_BASIC_USER
  const password = process.env.VUE_APP_LC_API_URL_BASIC_PASSWORD
  
  if (username && password) {
    return { username, password }
  }
  return null
}

export const NEW_API_AUTH = getApiAuth()

// 新API用の共通設定
export const NEW_API_CONFIG = {
  baseURL: NEW_API_BASE_URL,
  headers: NEW_API_HEADERS,
  auth: NEW_API_AUTH
}

// ローカルストレージに保存する時のキー名
export const PERSISTED_STATE_KEY = 'lc-app'

// お見積もり印刷機能で使用するパラメータ渡し用データ名
export const ESTIMATE_PRINT_DATA_NAME = 'lc_print_json'
// 印刷用Webウィンドウで使用するパラメータ渡し用データ名
export const WEB_WINDOW_PRINT_DATA_NAME = 'web_print_json'

// 一覧画面の初期スクロール位置設定対応のsetInterval()の実行間隔(ミリ秒)
export const SCROLL_INTERVAL_DELAY = 50
// 一覧画面の初期スクロール位置設定対応の対象HTML要素検索のsetInterval()の最大リトライ回数
export const SCROLL_INTERVAL_MAX_COUNT = 50

// 絞り込み表示用の検索条件の保存用パラメータに付与する接頭辞
export const PREFEX_EXTRACT_CONDITION = 'extract:'

export const PACKAGE_STATUS = {
  UNSIGNED: -1, // 未契約
  TRIAL: 1, // トライアル中
  END_TRIAL: 2, // トライアル済
  PENDING_APPROVAL: 3, // 承認処理中
  IN_USE: 4, // 利用中
  RESERVE_CANCEL: 5, // 解約予約済
  STOP: 6, // パッケージ停止中
  END: 7, // 契約終了
  VISIBLE_DETAIL_PACKAGE: [1, 4, 5], // 詳細へ遷移可能なパッケージステータス
  CAN_TRIAL_PACKAGE: [null, -1, 6, 7], // トライアル可能なパッケージステータス
  SIGNED_PACKAGE: [4, 5], // 契約中のパッケージ
  UNSIGNED_PACKAGE: [null, -1, 1, 2, 3, 6, 7] // 未契約のパッケージ
}

export const PACKAGE_STATUS_NAME = status => {
  return (() => {
    switch (status) {
      case PACKAGE_STATUS.UNSIGNED: return '未契約'
      case PACKAGE_STATUS.TRIAL: return '無料トライアル'
      case PACKAGE_STATUS.END_TRIAL: return 'トライアル済'
      case PACKAGE_STATUS.PENDING_APPROVAL: return '承認処理中'
      case PACKAGE_STATUS.IN_USE: return '自動継続'
      case PACKAGE_STATUS.RESERVE_CANCEL: return 'パッケージの解約予約有'
      case PACKAGE_STATUS.STOP: return '停止中'
      case PACKAGE_STATUS.END: return '契約終了'
      default: return ''
    }
  })()
}

export const PRODUCT_STATUS = {
  UNSIGNED: -1, // 未契約
  TRIAL: 1, // 無料トライアル
  SCRUTINY: 2, // 見積精査中
  PENDING_APPROVAL: 3, // 社内承認待ち
  WAIT_CONFRIM: 4, // 初回申込確定待ち
  ORDER_RECEIVED: 5, // 受注済み
  CANCEL_LICENSE: 6, // ライセンス一部解除
  CANCEL_PACKAGE: 7, // パッケージ・ライセンス解約予約
  END: 8, // 終了
  CONTEINUED: 9, // 継続済み
  DO_CANCEL_LICENSE: 10, // ライセンス一部解除予約実行済み
  DO_CANCEL_PACKAGE: 11, // パッケージ・ライセンス解約予約実行済み
  CANCEL_CANCEL: 12, // ライセンス取り消し
  CANCEL_CANCEL_PACKAGE: 13, // 取り消し済みパッケージ解約予約
  CANCEL_CANCEL_LICENSE: 14, // 取り消し済みライセンス解約予約
  CANCEL_CANCEL_LICENSE_PART: 15, // 取り消し済みライセンス一部解除予約
  SIGNED_PRODUCT: [5, 6, 7, 9], // 契約中の商品
  SIGNED_PRODUCT_INCLUDE_TRIAL: [1, 5, 6, 7, 9], // 契約中の商品（トライアル含む）
  UNSIGNED_PRODUCT: [-1, 1, 2, 3, 4, 8], // 未契約の商品
  CANCEL_PRODUCT: [6, 7], // 解約予約中の商品
  CANCEL_CANCEL_PRODUCT: [12, 13, 14, 15] // 解約予約の取り消し済み商品
}

export const PRODUCT_STATUS_NAME = status => {
  return (() => {
    switch (status) {
      case PRODUCT_STATUS.UNSIGNED: return '未契約'
      case PRODUCT_STATUS.TRIAL: return '無料トライアル'
      case PRODUCT_STATUS.SCRUTINY: return '見積精査中'
      case PRODUCT_STATUS.PENDING_APPROVAL: return '社内承認待ち'
      case PRODUCT_STATUS.WAIT_CONFRIM: return '初回申込確定待ち'
      case PRODUCT_STATUS.ORDER_RECEIVED: return '受注済み'
      case PRODUCT_STATUS.CANCEL_LICENSE: return 'ライセンス一部解除'
      case PRODUCT_STATUS.CANCEL_PACKAGE: return 'ライセンス解約予約'
      case PRODUCT_STATUS.END: return '終了'
      case PRODUCT_STATUS.CONTEINUED: return '継続済み'
      default: return ''
    }
  })()
}

export const PRODUCT_TYPE = {
  TRIAL: 1,
  FIRST_TIME: 2,
  ADD: 3,
  CANCEL: 4,
  PACKAGE_CANCEL: 5,
  LICENSE_CANCEL: 6,
  CONTINUE: 7,
  TOTAL: 8,
  APPLICATION_DOWNLOAD: 9,
  IS_PAYMENT: [2, 3, 7],
  IS_CANCEL: [4, 5, 6]
}

export const PRODUCT_TYPE_NAME = status => {
  return (() => {
    switch (status) {
      case PRODUCT_TYPE.TRIAL: return '無料トライアルの申込'
      case PRODUCT_TYPE.FIRST_TIME: return 'お見積もり'
      case PRODUCT_TYPE.ADD: return 'ライセンスの購入'
      case PRODUCT_TYPE.CANCEL: return 'ライセンスの解約（次年）'
      case PRODUCT_TYPE.PACKAGE_CANCEL: return 'ライセンスの解約（次年）'
      case PRODUCT_TYPE.LICENSE_CANCEL: return 'ライセンスの解約（次年）'
      case PRODUCT_TYPE.CONTINUE: return '自動継続'
      case PRODUCT_TYPE.TOTAL: return ''
      case PRODUCT_TYPE.APPLICATION_DOWNLOAD: return ''
    }
  })()
}

export const PRODUCT_CLASSIFICATION = {
  TRIAL: 1,
  BASIC: 2,
  OPTION: 3,
  ADD: 4,
  BUY: [2, 3]
}

export const SETTLEMENT_TYPE = {
  CREDIT_CARD: 1,
  ACCOUNT_TANSFER: 2,
  WEB_INVOICE: 9
}


/**
 * 本番環境か？
 * @returns 
 */
const isProduction = () => {
  const host = location.host
  return (host === 'www.sn-hoki.co.jp' || host === 'sn-hoki.co.jp')
}

export const getConstants = () => {

  // ### 外部URL ###

  // 「契約情報」画面の「既定のお支払い方法」欄で使用
  // LEGAL CONNECTIONクレジットカード設定
  const URL_CREDIT_SETTING = computed(() => {
    if (isProduction()) {
      return 'https://www.sn-hoki.co.jp/shop/account/lc/autopaymentcard'
    } else {
      return 'https://st-snhfront.aquaring.jp/shop/account/lc/autopaymentcard'
    }
  })

  // LEGAL CONNECTION自動決済解約申請フォーム
  const URL_AUTOPAYMENT_CANCEL = computed(() => {
    if (isProduction()) {
      return 'https://www.sn-hoki.co.jp/shop/account/lc/autopaymentstop'
    } else {
      return 'https://st-snhfront.aquaring.jp/shop/account/lc/autopaymentstop'
    }
  })

  // LEGAL CONNECTION WEB請求書解約申請フォーム
  const URL_WEB_INVOICE_CANCEL = computed(() => {
    if (isProduction()) {
      return 'https://www.sn-hoki.co.jp/shop/account/lc/paymentstop'
    } else {
      return 'https://st-snhfront.aquaring.jp/shop/account/lc/paymentstop'
    }
  })
  
  // LEGAL CONNECTION自動決済サービス
  const URL_WEB_AUTO_PAYMENT_SERVICE = computed(() => {
    if (isProduction()) {
      return 'https://www.sn-hoki.co.jp/guide/autolc/'
    } else {
      return 'https://st-snhfront.aquaring.jp/guide/autolc/'
    }

  })

  return {
    URL_CREDIT_SETTING,
    URL_AUTOPAYMENT_CANCEL,
    URL_WEB_INVOICE_CANCEL,
    URL_WEB_AUTO_PAYMENT_SERVICE
  }
}
